import { Teams } from "types/Player";
import ImagesUtils from "utils/images";
import { FunctionComponent } from "react";

type Props = {
  teams: string[];
  highlight?: string;
  direction?: "column" | "row";
};

const BonusTeam: FunctionComponent<Props> = ({ teams, direction = "column" }) => {
  const images = teams.map((team) => <img src={ImagesUtils.getTeamImage(team as Teams)} key={team} alt={team} />);

  return <div style={{ display: "flex", flexDirection: direction }}>{images}</div>;
};

export default BonusTeam;
